import { useEffect } from 'react';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollContainerElement = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ScrollContainer, {
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: '100vw'
      },
      children: children
    })
  });
};
export default function MobileFilterBar({
  children,
  startSlot,
  middleSlot
}) {
  useEffect(() => {
    if (children && startSlot) {
      console.warn('MobileFilterBar: children and startSlot cannot both be passed. Defaulting to startSlot');
    }
  }, [children, startSlot]);
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    maxInlineSize: "100vw",
    children: /*#__PURE__*/_jsx(FilterBar, {
      startSlot: startSlot,
      Middle: ScrollContainerElement,
      middleSlot: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "200",
        paddingBlockStart: "100",
        children: middleSlot
      }),
      responsive: false
    })
  });
}